// GradientHeading.jsx
// Reusable gradient heading component with V1 gradient
// Location: src/components/GradientHeading.jsx

import React from 'react';

/**
 * Gradient Heading Component
 * Displays text with the signature V1 gradient effect
 * 
 * @param {string} children - The text to display
 * @param {string} size - Text size: 'hero' (5xl), 'page' (4xl), 'section' (2xl)
 * @param {string} className - Additional Tailwind classes
 */
const GradientHeading = ({ 
  children, 
  size = 'page',
  className = '' 
}) => {
  // Map size prop to Tailwind classes
  const sizeClasses = {
    hero: 'text-5xl',
    page: 'text-4xl', 
    section: 'text-2xl'
  };

  const gradientStyle = {
    background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 50%, rgb(240, 147, 251) 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  };

  return (
    <h1 
      className={`${sizeClasses[size]} font-bold ${className}`}
      style={gradientStyle}
    >
      {children}
    </h1>
  );
};

export default GradientHeading;